// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"11ce4308","432":"79faae10","748":"9f7f1a45","980":"aa43d518"}[chunkId] + ".chunk.js";
};